<script lang="ts" setup>
import type {
  RouteLocationAsPathGeneric,
  RouteLocationAsRelativeGeneric,
} from 'vue-router';

/**
 * https://nuxt.com/docs/api/components/nuxt-link#props
 */
const {
  label,
  to = undefined,
  target = undefined,
  replace = false,
} = defineProps<{
  label: string;
  to?: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric;
  replace?: boolean;
  target?: string;
}>();
</script>

<template>
  <NuxtLink :to="to" :target="target" :replace="replace" class="app-link">
    {{ label }}
  </NuxtLink>
</template>

<style lang="scss" scoped>
.app-link {
}
</style>
